import { UseQueryOptions, useQuery } from '@hooks/react-query';
import { ApiError, ApiResult } from '@models/api';
import { PreLoanResponse } from '../models';

function useRGetSelectedLoan(
  options?: UseQueryOptions<ApiResult<PreLoanResponse>, ApiError>,
) {
  return useQuery({
    queryKey: ['loan/get_pre_loan'],
    enabled: true,
    ...options,
  });
}

export default useRGetSelectedLoan;
